import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { apiClient } from "../../api/api-client";
import { useState } from "react";

// Define types for the user login details and the response from the server
interface User {
  email: string;
  password: string;
}

interface SignInResponse {
  access_token: string;
  // Include other fields returned by the API if necessary
}

interface UseSignInResult {
  signInMutation: UseMutationResult<AxiosResponse<SignInResponse>, unknown, User>;
  visible: { password: boolean };
  handleShowPassword: () => void;
}

function useSignIn(): UseSignInResult {
  const signInMutation = useMutation<AxiosResponse<SignInResponse>, unknown, User>({
    mutationFn: async (user: User) => {
      return apiClient.post("/auth/login", user);
    },
  });

  const [visible, setVisible] = useState<{ password: boolean }>({
    password: false,
  });

  const handleShowPassword = () => {
    setVisible({ password: !visible.password });
  };

  return { signInMutation, visible, handleShowPassword };
}

export default useSignIn;
